/* KokoKids brand behaviours — intentionally tiny & dependency-free */
(function () {
  'use strict';

  /* ---- 1. Product image loader ----------------------------------------- */
  // Each product photo shows the pulsing elephant until its own image has
  // loaded. Photos are loading="lazy", so this is per image rather than
  // tied to window load, which doesn't wait for lazy images.
  //
  // The koko-js class gates the CSS: if this script never runs, photos are
  // never hidden. Load and error are caught on the document in the capture
  // phase, so images swapped in later (variant changes, lazy images scrolled
  // into view) are handled without re-binding. Error counts as done, so a
  // broken image can't leave the elephant spinning forever.
  document.documentElement.classList.add('koko-js');
  function markMediaLoaded(img) {
    var box = img.closest('.product-media-container .product__media');
    if (box) box.classList.add('koko-media-loaded');
  }
  function onMediaSettled(e) {
    if (e.target.tagName === 'IMG') markMediaLoaded(e.target);
  }
  document.addEventListener('load', onMediaSettled, true);
  document.addEventListener('error', onMediaSettled, true);
  document.querySelectorAll('.product-media-container .product__media img').forEach(function (img) {
    if (img.complete) markMediaLoaded(img);
  });

  /* ---- 2. Scroll-snap carousel arrows ---------------------------------- */
  function initCarousels(root) {
    var cars = (root || document).querySelectorAll('.koko-carousel');
    cars.forEach(function (car) {
      var track = car.querySelector('.koko-carousel__track');
      if (!track) return;

      // Arrows only make sense when the track actually overflows -- with a
      // couple of items on a wide screen there's nothing to scroll to, and
      // the buttons just float awkwardly at the far edges of the section.
      function updateOverflow() {
        var overflowing = track.scrollWidth > track.clientWidth + 4;
        car.classList.toggle('koko-carousel--no-overflow', !overflowing);
      }
      updateOverflow();
      window.addEventListener('resize', updateOverflow);
      if (window.ResizeObserver) new ResizeObserver(updateOverflow).observe(track);

      if (car.dataset.kokoInit) return;
      car.dataset.kokoInit = '1';
      var prev = car.querySelector('.koko-carousel__arrow--prev');
      var next = car.querySelector('.koko-carousel__arrow--next');
      function step() {
        var item = track.querySelector('.koko-carousel__item');
        return item ? item.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      }
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { initCarousels(); });
  // Re-init when the theme editor injects/reloads a section.
  document.addEventListener('shopify:section:load', function (e) { initCarousels(e.target); });

  /* ---- 3. Mobile bottom nav: active state + cart count ----------------- */
  document.addEventListener('DOMContentLoaded', function () {
    var path = window.location.pathname;
    document.querySelectorAll('.koko-mnav__item').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (href && href !== '/' && path.indexOf(href) === 0) a.classList.add('is-active');
      if (href === '/' && path === '/') a.classList.add('is-active');
    });
  });

  // Keep the mobile cart badge in sync with Dawn's cart updates.
  function syncCart(count) {
    var badge = document.getElementById('koko-cart-count');
    if (!badge) return;
    if (count > 0) { badge.textContent = count; badge.hidden = false; }
    else { badge.hidden = true; }
  }
  document.addEventListener('cart:update', function (e) {
    if (e.detail && typeof e.detail.itemCount === 'number') syncCart(e.detail.itemCount);
  });
  // Fallback: read Dawn's own bubble whenever it changes.
  var bubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
  if (bubble) {
    new MutationObserver(function () {
      syncCart(parseInt(bubble.textContent, 10) || 0);
    }).observe(bubble, { childList: true, characterData: true, subtree: true });
  }
})();
